const _version = "3.0.8"
function version() {
    return _version
}
export default version
